import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProjectsHero() {
  const { t } = useTranslation();

  const stats = [
    { value: '1000+', label: t('stats.completedProjects') },
    { value: '22+', label: t('stats.yearsExpShort') },
    { value: '20', label: t('stats.countries') },
  ];

  return (
    <section className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
      <img
        src="https://okayisu.com/common/img/site/projeler-img.jpg"
        alt="OKAYISU Projects"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/55 to-transparent" />
      <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-20 max-w-7xl mx-auto left-0 right-0">
        <nav className="flex items-center gap-2 mb-7" aria-label="Breadcrumb">
          <Link to="/" className="text-white/50 hover:text-amber-400 text-xs tracking-wide transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('navbar.home')}
          </Link>
          <i className="ri-arrow-right-s-line text-white/30 text-xs" />
          <span className="text-amber-400 text-xs tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('projects.hero.breadcrumb')}
          </span>
        </nav>
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-4 w-fit">
          <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" />
          <span className="text-white text-xs tracking-[0.2em] uppercase font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('projects.hero.badge')}</span>
        </div>
        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {t('projects.hero.heading1')}<br />
          <span className="text-amber-400">{t('projects.hero.heading2')}</span>
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-md leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('projects.hero.desc')}</p>
        <div className="flex flex-wrap gap-8 mt-8">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div className="text-amber-400 text-2xl font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{stat.value}</div>
              <div className="text-white/55 text-xs tracking-wide mt-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}